var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpenedColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86479 5.40798H2.47463C1.61073 5.40798 0.900024 6.11537 0.900024 6.9927V11.7759C0.914008 12.6675 1.61073 13.375 2.47463 13.375H9.52542C10.4033 13.3608 11.1 12.6533 11.1 11.7759V6.99295C11.086 6.10142 10.3893 5.39388 9.52542 5.39388H9.31842V5.39868H8.35498H8.35493H7.78842V5.39379L3.64519 5.39388V3.87969C3.64519 2.49286 4.60666 1.41742 6.01401 1.41742C7.43524 1.41742 8.35493 2.52116 8.35493 3.87969V3.94518H9.13525V3.87969C9.13525 2.08254 7.86723 0.625 6.01396 0.625C4.16064 0.625 2.86479 2.05428 2.86479 3.87969V5.40798ZM2.47461 12.5683C2.04267 12.5683 1.69431 12.2145 1.69431 11.7759V6.99287C1.69431 6.55422 2.04267 6.20045 2.47461 6.20045H9.52539C9.95733 6.20045 10.3057 6.55422 10.3057 6.99287V11.7759C10.3057 12.2145 9.95733 12.5683 9.52539 12.5683H2.47461ZM5.60986 9.28533C5.37298 9.1438 5.2197 8.88914 5.2197 8.59192C5.2197 8.13907 5.56811 7.78528 6.00005 7.7995C6.43199 7.7995 6.78035 8.15327 6.78035 8.59192C6.78035 8.88911 6.62706 9.14378 6.39019 9.28533V10.5872C6.39019 10.7994 6.223 10.9834 6.00002 10.9834C5.79104 10.9834 5.60986 10.8136 5.60986 10.5872V9.28533Z",
    fill: "url(#paint0_linear_6494_40878)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6494_40878",
    x1: 1.00159,
    y1: 1,
    x2: 11.0016,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08B16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#108E62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenedColored);
export default __webpack_public_path__ + "static/media/lock-opened-colored.ba32a62630ec31d75e60c44de0c7b80a.svg";
export { ForwardRef as ReactComponent };